import * as React from 'react';
import { List, ListItemButton, ListItemText } from '@mui/material';
import ForkRightIcon from '@mui/icons-material/ForkRight';

interface Props {
  questions: string[] | null;
  onClick: (question: string) => void;
}

export const FollowUpQuestions: React.FC<Props> = ({ questions, onClick }) => {
  if (!questions?.length) {
    return null;
  }

  const handleFollowUpQuestion = (question: string) => () => {
    onClick(question);
  };

  return (
    <List disablePadding>
      {questions.map((question, i) => (
        <ListItemButton
          sx={{ p: 0.5 }}
          onClick={handleFollowUpQuestion(question)}
          key={i}
        >
          <ForkRightIcon sx={{ pr: 0.5 }} fontSize="medium" />
          <ListItemText primary={question} />
        </ListItemButton>
      ))}
    </List>
  );
};
